// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { FormFieldStyle } from "@awc/MobiusOverrides/FormField";
import { columnsStyles } from "@awc/Overrides/Widgets/ProductList/ProductListColumns";
import { PLP_BREAKPOINT } from "@awc/XDL/constants";
import { color, xScreen } from "@awc/XDL/Utilities";
import { AccordionSectionHeaderProps } from "@insite/mobius/AccordionSection/AccordionSectionHeader";
import { css } from "styled-components";

columnsStyles.container = {
    css: css`
        display: grid;
        grid-template-columns: minmax(0, 330px) minmax(0, 1fr);
        gap: 32px 16px;
        ${({ showTableLayout }: any) => showTableLayout && `grid-template-columns: minmax(0, 1fr);`};
    `,
};

columnsStyles.accordionFilterStyles = {
    headerProps: {
        css: css`
            width: 110px;
            && {
                border-color: ${color("primary")};
            }
            ${({ expanded }: AccordionSectionHeaderProps) =>
                expanded &&
                css`
                    border-bottom: 0;
                `}
            ${xScreen("lte", "sm")} {
                width: 100%;
            }
        `,
    },
    panelProps: {
        css: css`
            border: 1px solid ${color("primary")};
            padding: 12px 14px;
            & > div:nth-child(2) {
                display: grid;
                grid-template-columns: repeat(3, 1fr);
                align-items: start;
                gap: 14px;

                ${FormFieldStyle}:nth-child(2),${FormFieldStyle}:nth-child(3) {
                    margin-top: 20px;
                }

                ${xScreen("lt", PLP_BREAKPOINT)} {
                    grid-template-columns: repeat(2, 1fr);
                    ${FormFieldStyle}:nth-child(3) {
                        margin-top: 0;
                    }
                }

                ${xScreen("lte", "sm")} {
                    grid-template-columns: 1fr;
                    ${FormFieldStyle}:nth-child(2),${FormFieldStyle}:nth-child(3) {
                        margin-top: 0;
                    }
                }
            }
        `,
    },
};
